import { Stack } from 'expo-router';
import React from 'react';

import ConversationalOnboardingQAHistoryPage from '../../../llm-service/conversational-mm/ConversationalOnboardingQAHistoryPage';

export default function ConversationalOnboardingQAHistoryRoute() {
    return (
        <>
            <Stack.Screen
                options={{
                    title: 'Simulation History',
                }}
            />
            <ConversationalOnboardingQAHistoryPage />
        </>
    );
}
